module.exports = __webpack_public_path__ + "img/7d4f123.png";